module.exports = __webpack_public_path__ + "static/media/asbnbook.9935ab16.jpg";